import React from 'react';
import { Button, Modal, toast, Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';
import { useNotifications, Notification } from '../../components/notifications/notificationsProvider';
import Style from './styles/partnerList.module.css';

export default function TemplateSelectionModal({
    showModal = false,
    setShowModal = () => {},
    organizationId = null,
    activePartnerIds = [],
    setSelectedPartners = () => {},
    setAllPartnersSelected = () => {},
    setSelectedPartner = () => {},
    selectedPartner = null,
    sync
}) {
    const { t } = useTranslation();

    const { addNotification } = useNotifications();

    const [loading, setLoading] = React.useState(false);

    const onClose = React.useCallback(() => {
        setShowModal(false);
        setSelectedPartners({});
        setAllPartnersSelected(false);
        setSelectedPartner(null);
    }, []);

    const handleDelete = React.useCallback(() => {
        setLoading(true);

        const deletePromise = selectedPartner
            ? selectedPartner.delete({ organizationId })
            : fetcher.post(`/ticket/organizations/${organizationId}/partners/actions`, {
                  data: { type: 'async_bulk_destroy', resource_query_filter: { id__in: activePartnerIds.join(',') } }
              });

        deletePromise
            .then(response => {
                if (selectedPartner) {
                    toast.success(t('ticket.partners.delete.success'));
                } else {
                    addNotification(
                        new Notification('async_actions', 'async_bulk_destroy', 'partners', response?.response?.task_id, {
                            success: 'ticket.partnersList.modal.to_delete.toast-success',
                            error: 'ticket.partnersList.modal.to_delete.toast-error'
                        })
                    );
                    toast.info(t('ticket.manager.attendees.action.generic.toast.async'));
                }
                sync();
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.partners.delete.error'));
            })
            .finally(() => {
                setLoading(false);
                onClose();
            });
    }, [selectedPartner, organizationId, sync, onClose, addNotification, activePartnerIds]);

    return (
        <Modal
            allowExternalClosing={true}
            open={showModal}
            onClose={onClose}
            title={t('ticket.partnersList.modal.to_delete.title', { count: Object.keys(activePartnerIds).length })}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.close')} />}
            submitButton={<Button primary isLoading={loading} onClick={handleDelete} label={t('ticket.common.action.save')} />}
        >
            <>
                <div>{t('ticket.partnersList.modal.to_delete.description', { count: Object.keys(activePartnerIds).length })}</div>
                <Message title={t('ticket.partnersList.modal.to_delete.info_title')} type="danger" className={Style['margin-top-small']}>
                    <div>{t('ticket.partnersList.modal.to_delete.info_message', { count: Object.keys(activePartnerIds).length })}</div>
                </Message>
            </>
        </Modal>
    );
}
